import _debounce from 'lodash/debounce';
import { calculateBrowserWidth } from 'services/Ad/utils/browser';

export const leaderBoardManger = () => {
  let stickyFlag = true;
  const hangTime = 4000;
  // poll to see  if the leaderboard has loaded
  const leaderboardCheck = setInterval(() => {
    const leader = document.getElementById('Leaderboard0');
    if (leader.clientHeight > 0) {
      clearInterval(leaderboardCheck);
      function onScroll(leaderboardHeight: number, root: HTMLElement) {
        requestAnimationFrame(() => {
          const crownIframe = document.querySelector('.cc-height iframe') as HTMLElement;

          // Used to check for the crown ad when consent is rejected/accepted.
          if (crownIframe && crownIframe.clientHeight) {
            const currentHeight = crownIframe.clientHeight;
            if (window.scrollY === 0) root.style.setProperty('--ld-height', `${leaderboardHeight}px`);
            else root.style.setProperty('--ld-height', `${currentHeight}px`);
          }
          // set height to 0 when crown ad is not present for the navbar to be sticky to the top of page
          else root.style.setProperty('--ld-height', `${0}px`);
        });
      }
      const debounceScrollFn = _debounce(onScroll, 200);
      function validateAdHeightOnScroll(leaderboardHeight: number, root: HTMLElement) {
        document.addEventListener('scroll', () => {
          debounceScrollFn(leaderboardHeight, root);
        });
      }
      function getLeaderboardHeight(clientWidth: number) {
        let leaderboardHeight = 110;
        const isTablet = clientWidth >= 768 && clientWidth < 1024;
        const isDesktop = clientWidth >= 1024;
        switch (true) {
          case isTablet:
            leaderboardHeight = 160;
            break;
          case isDesktop:
            leaderboardHeight = 300;
            break;
          default:
            return 110;
        }
        return leaderboardHeight;
      }

      const ClientWidth = calculateBrowserWidth();
      const root = document.querySelector<HTMLElement>(':root');
      const parentLeader = document.querySelector('.leaderboard-ad-wrapper-parent');
      const leaderboardIframe = document.querySelector('.leaderboard-ad-wrapper-parent iframe');

      // get the leaderboard height depending on client width
      const leaderboardHeight = getLeaderboardHeight(ClientWidth);

      const height = leaderboardIframe?.clientHeight;
      const width = leaderboardIframe?.clientWidth;

      const CheckCrown = (width === 970 && height === 90) || (width === 300 && height === 50);
      const isNonCrown = !CheckCrown;
      setTimeout(() => {
        if (parentLeader.classList.contains('cc-height')) {
          requestAnimationFrame(() => {
            parentLeader?.classList?.remove('leaderboard--scroll'); // should remove if swapping from non crown to crown
            root.style.setProperty('--ld-height', `${leaderboardHeight}px`);
            validateAdHeightOnScroll(leaderboardHeight, root);
          });
        }
      }, 3000);
      const scrollListenerNonCrown = () => {
        if (window.scrollY > 25) {
          parentLeader.classList.add('leaderboard--scroll');
          document.removeEventListener('scroll', scrollListenerNonCrown);
        }
      };

      if (isNonCrown) {
        if (stickyFlag) {
          root.style.setProperty('--ld-height', `${leaderboardHeight}px`);
          parentLeader.classList.add('leaderboard--sticky');
          if (ClientWidth <= 820) {
            requestAnimationFrame(() => {
              root.style.setProperty('--ld-height', `${height}px`);
              document.addEventListener('scroll', scrollListenerNonCrown);
            });
          }
        }

        setTimeout(() => {
          stickyFlag = false;
          if (ClientWidth > 820) {
            parentLeader.classList.remove('leaderboard--sticky');
            root.style.setProperty('--ld-height', '0px');
          }
        }, hangTime);

        if (stickyFlag && ClientWidth >= 576) {
          setTimeout(() => {
            if (parentLeader.classList.contains('cc-height') || CheckCrown)
              document.querySelector('.rr-sticky-hub')?.classList.add('is-sticky-cc-height');
            else document.querySelector('.rr-sticky-hub')?.classList.add('is-sticky');
          }, hangTime);
        }
      } else if (parentLeader.classList.contains('cc-height') || CheckCrown)
        document.querySelector('.rr-sticky-hub')?.classList.add('is-sticky-cc-height', 'lg');
      else document.querySelector('.rr-sticky-hub')?.classList.add('is-sticky', 'lg');
    }
  }, 500);
};
